async function loadMoreProducts() {
    const collectionGrid = document?.querySelector(".collection");
    const productGrid = document?.querySelector('#product-grid');
    const loadMoreBlock = document?.querySelector('.load-more__inner');
    const {value: pageUrl } = loadMoreBlock?.querySelector('.url_page');
    const {value: totalPage } = loadMoreBlock?.querySelector('.total__page');
    const loaderButton = document?.querySelector('.load-more-button');

    try {
        collectionGrid.classList.add('loading');
        const response = await fetch(pageUrl);
        const data = await response.text();

        const parser = new DOMParser();
        const parsedHTML = parser.parseFromString(data, 'text/html');
        
        const newProductGrid = parsedHTML.querySelectorAll('#product-grid .grid__item');

        if (newProductGrid.length > 0) {
            newProductGrid.forEach((div) => productGrid.append(div));

            const newloadMoreBlock = parsedHTML.querySelector('.load-more__inner');
            const {value: newPageUrl } = newloadMoreBlock.querySelector('.url_page');
            const {value: newCurrentPage } = newloadMoreBlock.querySelector('.current__page');
            loadMoreBlock.querySelector('.url_page').value = newPageUrl;

            if (newCurrentPage === totalPage) {
                loaderButton.remove();
            }

            collectionGrid.classList.remove('loading');
        } else {
            console.error('No new posts found');
        }
    } catch (error) {
        console.error('Error loading more posts:', error);
    }
}